var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.539,
    height: 53.129,
    viewBox: "0 0 45.539 53.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4515",
    d: "M0 0H25.047V35.672H0z",
    className: "cls-1",
    "data-name": "Rect\\xE1ngulo 4515",
    transform: "matrix(.995 -.105 .105 .995 0 2.618)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4514",
    d: "M0 0H45.539V53.129H0z",
    className: "cls-1",
    "data-name": "Rect\\xE1ngulo 4514"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-3{clip-path:url(#clip-path-2)}.cls-4{fill:#272727}.cls-5{fill:#0089c3}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11744",
    "data-name": "Grupo 11744",
    transform: "translate(-124.303 -99.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11504",
    "data-name": "Grupo 11504",
    transform: "translate(124.303 99.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11497",
    "data-name": "Grupo 11497",
    transform: "translate(9.429 7.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11496",
    clipPath: "url(#clip-path)",
    "data-name": "Grupo 11496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11495",
    "data-name": "Grupo 11495",
    transform: "translate(-9.429 -7.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11494",
    className: "cls-3",
    "data-name": "Grupo 11494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11493",
    "data-name": "Grupo 11493",
    transform: "translate(8.595 7.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25846",
    d: "M135.951 145.733l-3.887-36.987 26.419-2.776 3.888 36.986zm-2.219-35.633l3.57 33.967 23.4-2.46-3.57-33.967z",
    className: "cls-4",
    "data-name": "Trazado 25846",
    transform: "translate(-132.064 -105.97)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11503",
    "data-name": "Grupo 11503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11502",
    className: "cls-3",
    "data-name": "Grupo 11502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11498",
    "data-name": "Grupo 11498",
    transform: "translate(2.194 14.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25847",
    d: "M134.477 150.078l-8.193-35.486 6.022-1.592a.38.38 0 1 1 .194.734l-5.311 1.406 7.856 34.03 24.035-5.548a.38.38 0 1 1 .171.74z",
    className: "cls-4",
    "data-name": "Trazado 25847",
    transform: "translate(-126.284 -112.985)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11499",
    "data-name": "Grupo 11499",
    transform: "translate(35.562 2.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25848",
    d: "M156.794 105.9a.379.379 0 0 1-.295-.618l2.255-2.785a.38.38 0 1 1 .59.477l-2.256 2.785a.376.376 0 0 1-.294.141z",
    className: "cls-4",
    "data-name": "Trazado 25848",
    transform: "translate(-156.414 -102.356)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11500",
    "data-name": "Grupo 11500",
    transform: "translate(31.06 1.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25849",
    d: "M153.1 105.465a.379.379 0 0 1-.377-.34l-.374-3.564a.379.379 0 0 1 .754-.08l.374 3.565a.378.378 0 0 1-.337.416z",
    className: "cls-4",
    "data-name": "Trazado 25849",
    transform: "translate(-152.349 -101.142)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11501",
    "data-name": "Grupo 11501",
    transform: "translate(36.217 9.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25850",
    d: "M157.386 109.277a.379.379 0 0 1-.04-.756l3.564-.374a.379.379 0 1 1 .08.754l-3.564.374a.24.24 0 0 1-.04.002z",
    className: "cls-4",
    "data-name": "Trazado 25850",
    transform: "translate(-157.006 -108.144)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11505",
    "data-name": "Grupo 11505",
    transform: "translate(138.121 114.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25851",
    d: "M139.686 118.966a2.913 2.913 0 1 1 .3-.016c-.101.011-.2.016-.3.016zm0-5.248c-.081 0-.161 0-.243.012a2.341 2.341 0 1 0 .243-.012z",
    "data-name": "Trazado 25851",
    transform: "translate(-136.78 -113.15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11506",
    "data-name": "Grupo 11506",
    transform: "translate(144.735 114.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25852",
    d: "M143.037 114.559a.284.284 0 0 1-.03-.567l10.231-1.1a.288.288 0 0 1 .313.253.285.285 0 0 1-.252.313l-10.231 1.1z",
    className: "cls-4",
    "data-name": "Trazado 25852",
    transform: "translate(-142.753 -112.888)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11507",
    "data-name": "Grupo 11507",
    transform: "translate(145.056 117.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25853",
    d: "M143.327 117.353a.285.285 0 0 1-.03-.568l8.135-.886a.281.281 0 0 1 .313.251.285.285 0 0 1-.253.313l-8.135.887z",
    className: "cls-4",
    "data-name": "Trazado 25853",
    transform: "translate(-143.043 -115.896)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11508",
    "data-name": "Grupo 11508",
    transform: "translate(144.894 116.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25854",
    d: "M143.181 115.924a.284.284 0 0 1-.031-.567l6.919-.762a.281.281 0 0 1 .315.252.284.284 0 0 1-.252.313l-6.919.761a.146.146 0 0 1-.032.003z",
    className: "cls-4",
    "data-name": "Trazado 25854",
    transform: "translate(-142.896 -114.593)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11510",
    "data-name": "Grupo 11510",
    transform: "translate(145.742 124.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11509",
    "data-name": "Grupo 11509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25855",
    d: "M143.975 123.384a.285.285 0 0 1-.06-.566l10.232-1.1a.285.285 0 0 1 .06.566l-10.231 1.1z",
    className: "cls-5",
    "data-name": "Trazado 25855",
    transform: "translate(-143.662 -121.715)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11512",
    "data-name": "Grupo 11512",
    transform: "translate(146.064 127.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11511",
    "data-name": "Grupo 11511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25856",
    d: "M144.265 126.177a.285.285 0 0 1-.06-.566l8.137-.886a.285.285 0 0 1 .06.566l-8.135.886z",
    className: "cls-5",
    "data-name": "Trazado 25856",
    transform: "translate(-143.952 -124.724)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11514",
    "data-name": "Grupo 11514",
    transform: "translate(145.902 125.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11513",
    "data-name": "Grupo 11513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25857",
    d: "M144.119 124.749a.285.285 0 0 1-.06-.566l6.919-.762a.285.285 0 0 1 .06.566l-6.919.762z",
    className: "cls-5",
    "data-name": "Trazado 25857",
    transform: "translate(-143.806 -123.42)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11515",
    "data-name": "Grupo 11515",
    transform: "translate(139.996 133.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25858",
    d: "M141.38 135.82a2.908 2.908 0 0 1-2.255-4.743 2.909 2.909 0 0 1 5.15 1.536 2.912 2.912 0 0 1-2.595 3.192 2.748 2.748 0 0 1-.3.015zm.007-5.248a2.267 2.267 0 0 0-.245.013 2.339 2.339 0 1 0 2.566 2.086 2.34 2.34 0 0 0-2.321-2.1z",
    "data-name": "Trazado 25858",
    transform: "translate(-138.473 -130.004)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11516",
    "data-name": "Grupo 11516",
    transform: "translate(146.61 132.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25859",
    d: "M144.73 131.414a.285.285 0 0 1-.03-.568l10.232-1.1a.285.285 0 1 1 .06.566l-10.231 1.1z",
    className: "cls-4",
    "data-name": "Trazado 25859",
    transform: "translate(-144.446 -129.743)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11517",
    "data-name": "Grupo 11517",
    transform: "translate(146.931 136.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25860",
    d: "M145.02 134.207a.284.284 0 0 1-.03-.567l8.135-.887a.285.285 0 0 1 .062.566l-8.137.886a.141.141 0 0 1-.03.002z",
    className: "cls-4",
    "data-name": "Trazado 25860",
    transform: "translate(-144.736 -132.751)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11518",
    "data-name": "Grupo 11518",
    transform: "translate(146.769 134.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25861",
    d: "M144.874 132.778a.284.284 0 0 1-.031-.567l6.919-.761a.279.279 0 0 1 .315.251.283.283 0 0 1-.251.313l-6.919.762z",
    className: "cls-4",
    "data-name": "Trazado 25861",
    transform: "translate(-144.589 -131.447)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11519",
    "data-name": "Grupo 11519",
    transform: "translate(140.551 122.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25862",
    d: "M140.9 125.769a.8.8 0 0 1-.507-.181l-1.418-1.153.36-.441 1.416 1.152a.232.232 0 0 0 .175.052.242.242 0 0 0 .162-.086l4.016-4.94.442.36-4.017 4.939a.8.8 0 0 1-.544.293.729.729 0 0 1-.085.005z",
    className: "cls-5",
    "data-name": "Trazado 25862",
    transform: "translate(-138.974 -120.172)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11520",
    "data-name": "Grupo 11520",
    transform: "translate(139.049 124.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25863",
    d: "M140.525 127.529a2.909 2.909 0 1 1 1.96-5.06l-.384.421a2.339 2.339 0 1 0 .752 1.491l.567-.059a2.912 2.912 0 0 1-2.595 3.192c-.101.009-.201.015-.3.015z",
    className: "cls-5",
    "data-name": "Trazado 25863",
    transform: "translate(-137.618 -121.71)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.d0dd0bc282080775653c888bfdc68f07.svg";
export { ForwardRef as ReactComponent };